import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Paper,
  DialogContentText,
} from "@mui/material";
import Close from '@mui/icons-material/Close';
import { Box } from "@mui/material";
import { IconButton } from "@mui/material";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { create } from 'zustand';


type ConfirmDialogStore = {
  message: string;
  onSubmit?: () => void;
  close: () => void;
}

const useConfirmDialogStore = create<ConfirmDialogStore>((set) => ({
  message: "",
  onSubmit: undefined,
  close: () =>
    set({
        onSubmit: undefined,
      }),
}));

export const confirmDialog = (message: string, onSubmit: any ) => {
  console.log(message, onSubmit);
  useConfirmDialogStore.setState({
    message,
    onSubmit,
  })
  
}

const ConfirmDialog: React.FC = () => {
  const { message, onSubmit, close } = useConfirmDialogStore();
  return (
      <Dialog open={Boolean(onSubmit)} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Action</DialogTitle>
        <Box position="absolute" top={0} right={0} >
          <IconButton onClick={close}>
            <Close />
          </IconButton>
        </Box>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined"  color="primary" onClick={close}>
            Cancel
          </Button>
          <Button color="success" variant="contained" onClick={() => {
              if (onSubmit) {
                 onSubmit();
              }
              close();
          }}>
            <Typography color="#FFF">Yes</Typography>
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default ConfirmDialog;